import { LitElement, css, html } from '@lit'

class NovaHeader extends LitElement {
  static properties = {
    isSticky: {
      type: Boolean,
      attribute: 'is-sticky',
    },
    isTransparent: {
      type: Boolean,
      attribute: 'is-transparent',
    },
    isScrolled: {
      type: Boolean,
      reflect: true,
      attribute: 'is-scrolled',
    },
    isHovered: {
      type: Boolean,
      reflect: true,
      attribute: 'is-hovered',
    },
    isDrawerOpen: {
      type: Boolean,
      reflect: true,
      attribute: 'is-drawer-open',
    },
  }

  constructor() {
    super()
    this.isScrolled = false
    this.isHovered = false
    this.isDrawerOpen = false
  }

  connectedCallback() {
    super.connectedCallback()

    if (this.isSticky) {
      this.parentElement.classList.add('is-sticky')
    }

    window.addEventListener('scroll', this.onScrollHandler)
    this.addEventListener('mouseover', this.onHoverHandler)
    this.addEventListener('mouseout', this.offHoverHandler)
    window.addEventListener('nova:header-drawer:open', this.headerDrawerOpen)
    window.addEventListener('nova:header-drawer:close', this.headerDrawerClose)
  }

  disconnectedCallback() {
    super.disconnectedCallback()

    window.removeEventListener('scroll', this.onScrollHandler)
    this.removeEventListener('mouseover', this.onHoverHandler)
    this.removeEventListener('mouseout', this.offHoverHandler)
    window.removeEventListener('nova:header-drawer:open', this.headerDrawerOpen)
    window.removeEventListener(
      'nova:header-drawer:close',
      this.headerDrawerClose,
    )
  }

  onScrollHandler = () => {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop

    if (scrollTop > 0) {
      // Scrolled below the fold
      if (!this.isScrolled) {
        this.isScrolled = true
      }
    } else {
      // Scrolled above the fold
      if (this.isScrolled) {
        this.isScrolled = false
      }
    }
  }

  onHoverHandler = () => {
    if (!this.isHovered) {
      this.isHovered = true
    }
  }

  offHoverHandler = () => {
    if (this.isHovered) {
      this.isHovered = false
    }
  }

  headerDrawerOpen = () => {
    if (!this.isDrawerOpen) {
      this.isDrawerOpen = true
    }
  }

  headerDrawerClose = () => {
    if (this.isDrawerOpen) {
      this.isDrawerOpen = false
    }
  }

  render() {
    return html`
      <div class="container">
        <slot></slot>
      </div>
    `
  }

  static styles = css`
    :host {
      display: block;
      position: relative;
      background-color: var(--header-bg-color);
      transition: background-color 250ms;
      z-index: var(--nova-z-index-sticky);
    }

    :host([is-sticky]) {
      position: static;
    }

    :host([is-sticky][is-scrolled]) {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
    }

    :host([is-transparent]) {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
    }

    :host([is-sticky][is-transparent]) {
      position: fixed;
    }

    :host([is-transparent][is-sticky][is-scrolled]),
    :host([is-transparent][is-sticky][is-hovered]),
    :host([is-transparent][is-sticky][is-drawer-open]) {
      background-color: var(--nova-brand-reverse);
    }

    .container {
      background-color: var(--nova-background, transparent);
      left: 0;
      top: 0;
      transform: translateY(0);
      transition: transform var(--nova-duration-long, 1000ms);
      width: 100%;
      z-index: 10;
      position: relative;
    }
  `
}

customElements.define('nova-header', NovaHeader)
